import { memo, MouseEvent } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { RiMapPinLine } from 'react-icons/ri';

import { ChooseCardContent } from '@/resources/components/cart/shipment/chooseCardWrapper/ChooseCardContent';
import { IAddressResponse } from '@/routes/addresses';
import { getFullAddress } from '@/services/global';
import { IIntegration } from '@/store/ducks/integrations/types';
import { IAddress } from '@/store/ducks/order/types';

import StoreAddress from './StoreAddress';

interface Props {
  data: IIntegration | IAddressResponse;
  type: 'in-store' | 'address';
  onClick: (e: MouseEvent<HTMLDivElement>) => void;
}

function IntegrationOption({ data, type, onClick }: Props) {
  const getAttributes = () => {
    if (type === 'in-store') {
      return { 'data-store-id': (data as IIntegration).shop_id };
    }

    return { 'data-address-id': data.id };
  };

  return (
    <button key={`item-${data.id}`} type="button" className={`btn-block m-0 btn-list-wrapper`}>
      <ChooseCardContent
        key={data.id}
        atributes={getAttributes()}
        handleClick={(e: MouseEvent<HTMLDivElement>) => onClick(e)}
        styles={{ background: 'transparent' }}
        classes="w-100 mb-2  btn-list"
      >
        <div className="d-flex align-items-center m-0">
          <Container className="address-container">
            <Row className="d-flex align-items-center w-100">
              <div className="ml-3 d-flex justify-content-center mr-3">
                <RiMapPinLine color="secondary" size={24} />
              </div>

              <Col>
                <Row className="address-wrapper mr-0 text-justify">
                  {type === 'in-store' && <StoreAddress integration={data as IIntegration} />}

                  {type === 'address' && (
                    <p className="m-0" style={{ fontSize: '14px', fontWeight: 450 }}>
                      {getFullAddress(data as IAddress, true)}
                    </p>
                  )}
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
      </ChooseCardContent>
    </button>
  );
}

export default memo(IntegrationOption);
